import apiClient, { getHeaders } from "./axios-client";

// eslint-disable-next-line no-unused-vars
const mockRes = {
  profileID: 4,
  propertyCode: "1070501043.00",
  requestDate: null,
  zoneKey: 1,
  zoneName: "पिंपरी नगर",
  gatKey: 85,
  gatName: "5",
  propertyKey: 230353,
  propertyName: "मा.सरकार, भोग.केवलानी करतार उत्तमचंद",
  propertyAddress: "प्लॉट  नं.३३७. सीटी स्हे नं.१३६९पींपरी पुणे",
  ratablevaluesum: 19620,
  ownerName: "मा.सरकार, भोग.केवलानी करतार उत्तमचंद",
  mobileNumber: "8446000950",
  lblBalanceAmount: "42972.0",
  lblConsAmt: "0.0",
  lblTotalAmt: "42972",
  txtPaidAmount: "42972",
  lblFineManpaBal: null,
  lblFineGovBal: null,
  lblFineTotal: null,
  lblTotalBal: null,
  lblNivvalBaki: null,
  lblTotalPaid: null,
  lblTotalBalAmount: null,
  lblFajilbal: "0.0",
  lblIllegalFajil: "0.0",
  finalusetype: "मिश्र",
  yearWiseBillLst: [
    {
      propertyCode: "1070501043.00",
      financialYear: "2024-2025",
      billNo: "2425070500986",
      balanceAmount: 12143,
    },
    {
      propertyCode: "1070501043.00",
      financialYear: "2023-2024",
      billNo: "2324070500996",
      balanceAmount: 18033,
    },
    {
      propertyCode: "1070501043.00",
      financialYear: "2022-2023",
      billNo: "2223070500919",
      balanceAmount: 12796,
    },
  ],
  lstConcessionType: ["PartlyPayment"],
};

// const getHeaders = () => {
//   const { profileId, zoneKey, userCode, userId } = getUserDetails();
//   return {
//     "Profile-ID": profileId,
//     "Zone-Key": zoneKey,
//     "User-Code": userCode,
//     "User-ID": userId,
//   };
// };

// const apiClient = axios.create({
//   baseURL: `${BASE_URL}${CONTEXT_ROOT}`,
//   headers: {
//     ...getHeaders(),
//   },
// });

/**
 *
 * @returns Counter Receipt Details
 */
export const getCounterReceiptDetails = async (propertyCode) => {
  const body = {
    propertyCode: propertyCode.toString() || "",
    requestDate: "",
    profileID: "",
  };
  const response = await apiClient.post(
    `/receipt/get-counter-receipt-details`,
    body
  );
  return response.data;

  // return mockRes;
};

/**
 * get Mode Of Payments
 * @returns
 */
export const getModeOfPayments = async () => {
  const headers = getHeaders();
  const response = await apiClient.get(
    `/master/getModeOfPayments?profileId=${headers["Profile-ID"]}`
  );
  return response.data;
};

/**
 * get-bank-details
 * @returns
 */
export const getBankDetails = async () => {
  const response = await apiClient.get(`/master/get-bank-details`);
  return response.data;
};

/**
 * get-bank-details
 * @returns
 */
export const getBankArea = async () => {
  const response = await apiClient.get(`/master/get-bank-area`);
  return response.data;
};
/**
 * get receipt details
 * @returns
 */
export const getReceiptList = async (params) => {
  //1070601157.00
  // eslint-disable-next-line no-unused-vars
  const { propertyNumber, receiptType } = params;
  const response = await apiClient.get(
    `/receipt/getPrintReceiptNo?propertyno=${propertyNumber}&receipttype=${receiptType}`
  );
  return response.data;
};

/**
 * get print receipt details
 * @returns
 */
export const getPrintReceiptDetails = async (receiptNo, receiptType) => {
  const response = await apiClient.get(
    `/receipt/print-counter-receipt?receiptno=${receiptNo}&receipttype=${receiptType}`
  );
  return response.data;
};

export const generateReceipt = async (body) => {
  const response = await apiClient.post(`/receipt/generate-receipt`, body);
  return response.data;
};

export const getConcessionAmount = async (body) => {
  const response = await apiClient.post(`receipt/get-concession-amount`, body);
  return response.data;
};
